import React from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Skeleton } from "antd-mobile";
import { isEmpty } from "lodash";
import useCustomTranslation from "@/hooks/useTranslation";
import useRouter from "@/hooks/useRouter";

const ChartsMonthly: React.FC<{ data: Record<string, any> }> = ({ data }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { customNavigate } = useRouter();

	return (
		<div className={`${classes.chartsMonthlyWrap}`}>
			<div className="detailNum">
				<div
					className="increase"
					style={{
						gridColumnStart: 1,
						gridColumnEnd: 3,
						width: "auto",
					}}
				>
					<div>{t("Members")}</div>
					{!isEmpty(data) ? (
						<strong>{data.members || 0}</strong>
					) : (
						<Skeleton animated className="skel" />
					)}
				</div>
				<div className="increase">
					<div style={{ display: "flex", justifyContent: "center" }}>
						<p>{t("Active")}</p>&nbsp;<p>{t("Member")}</p>
					</div>
					{!isEmpty(data) ? (
						<strong>{data.activeMembers || 0}</strong>
					) : (
						<Skeleton animated className="skel" />
					)}
				</div>
				<div
					onClick={() => {
						customNavigate("/other-member?t=" + Date.now());
					}}
					className="increase"
				>
					<div>
						<p>{t("OtherMember")}</p>
					</div>
					{!isEmpty(data) ? (
						<strong>{data.otherAgentMembers || 0}</strong>
					) : (
						<Skeleton animated className="skel" />
					)}
				</div>
			</div>
			{/* 待计算的值 */}
			{/* <div className="charts">
				<div className="cakebox">
					<ProgressCircle
						percent={membersProgressCircle}
						style={{
							"--size": pxToRem(156),
							"--track-color": "#1F2745",
							"--fill-color": getRiskColosPercentage(
								membersProgressCircle
							),
							"--track-width": pxToRem(30),
						}}
					>
						<div className="num">{membersProgressCircle}%</div>
						<div className="mm">{t("MonthlyActive")}</div>
						<div className="num">{data.activeMembers || 0}</div>
					</ProgressCircle>
				</div>
				<div className="cakebox">
					<ProgressCircle
						percent={monthIncrProgressCircle}
						style={{
							"--size": pxToRem(156),
							"--track-color": "#1F2745",
							"--fill-color": getRiskColosPercentage(
								monthIncrProgressCircle
							),
							"--track-width": pxToRem(30),
						}}
					>
						<div className="num">{monthIncrProgressCircle}%</div>
						<div className="mm">{t("DepositMembers")}</div>
						<div className="num">{data.rechargeMembers || 0}</div>
					</ProgressCircle>
				</div>
			</div> */}
		</div>
	);
};

export default ChartsMonthly;

const useStyles = createUseStyles({
	chartsMonthlyWrap: {
		"& .detailNum": {
			display: "grid",
			gridTemplateColumns: `${pxToRem(164)} ${pxToRem(164)}`,
			gridTemplateRows: "1fr 1fr",
			gridRowGap: pxToRem(10),
			gridColumnGap: pxToRem(5),
			padding: {
				top: pxToRem(10),
				left: pxToRem(20),
				right: pxToRem(20),
			},
			"& .increase": {
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				width: pxToRem(164),
				height: pxToRem(80),
				padding: {
					top: pxToRem(2),
					bottom: pxToRem(2),
				},
				borderRadius: pxToRem(14),
				textAlign: "center",
				border: "1px solid #3A375D",
				backgroundColor: "#181B24",
				"& div": {
					color: "#868FA8",
					fontSize: pxToRem(15),
					fontWeight: "500",
					lineHeight: pxToRem(18),
					marginBottom: pxToRem(2),
					padding: {
						left: pxToRem(5),
						right: pxToRem(5),
					},
				},
				"& strong": {
					color: "#FFFFFF",
					fontSize: pxToRem(30),
					fontWeight: "700",
					lineHeight: pxToRem(36),
				},
				"& .skel": {
					height: pxToRem(36),
					width: "80%",
					margin: "0 auto",
				},
			},
		},
		"& .charts": {
			"& .cakebox": {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				width: pxToRem(180),
				height: pxToRem(180),
				borderRadius: "100%",
				backgroundColor: "#1A1D2A",
				"&:first-of-type": {
					marginBottom: pxToRem(10),
				},
			},
			"& .num": {
				color: "#FFFFFF",
				fontSize: pxToRem(18),
				fontWeight: "600",
				lineHeight: pxToRem(28),
			},
			"& .mm": {
				color: "#868FA8",
				fontSize: pxToRem(12),
				fontWeight: "400",
				lineHeight: pxToRem(18),
			},
		},
	},
});
